"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated Look into why this exists.
 */
var EntitiesModel = /** @class */ (function () {
    function EntitiesModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/events",
            UPDATE: APPURL + "/api/v1/events",
            CREATE: APPURL + "/api/v1/events",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
        this.isDriveSession = this.isDriveSession.bind(this);
        this.isCourse = this.isCourse.bind(this);
        this.isEvent = this.isEvent.bind(this);
        this.isRTO = this.isRTO.bind(this);
    }
    /////////////////////////////////////
    EntitiesModel.prototype.extract = function (result) {
        return result.data;
    };
    EntitiesModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    EntitiesModel.prototype.isDriveSession = function (item) {
        return item.type === "Drive Session";
    };
    EntitiesModel.prototype.isCourse = function (item) {
        return item.type === "Course";
    };
    EntitiesModel.prototype.isEvent = function (item) {
        return item.type === "Event";
    };
    EntitiesModel.prototype.isRTO = function (item) {
        return item.typeDisplay === "RTO";
    };
    return EntitiesModel;
}());
EntitiesModel.$inject = ["$http", "APPURL"];
exports.default = EntitiesModel;
